// 日期格式化
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds()
    // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '')
      .substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k])
        : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
/**
 * 日期格式化 value 时间戳 format 日期格式化
 * @param value
 * @param format
 * @returns {string}
 */
export function formatTime (value, format) {
  if (value == null || value == '') {
    return ''
  }
  return new Date(value).Format(format)
}
/**
 * 生成32位UUID
 * @returns {string}
 */
export function guid () {
  var uuid36 = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
  var reg = new RegExp('-', 'g')// g,表示全部替换。
  var uuid32 = uuid36.replace(reg, '')
  return uuid32
}
/**
 * 判断字符串是否为空
 * @param str
 * @returns
 */
export function isNullOrEmptyStr (str) {
  if (str == null) {
    return true
  }
  if (str.trim() == '') {
    return true
  }
  return false
}
/**
 * 判断集合是否为空
 * @param arr
 * @returns
 */
export function isNullOrEmptyArr (arr) {
  if (arr == null || arr.legth == 0) {
    return true
  }
  return false
}
/**
 * 根据ID进行数据的删除
 * @param originalArr
 * @param delArr
 */
export function reomveArrById (originalArr, delArr) {
  for (var i = originalArr.length - 1; i >= 0; i--) {
    var row = originalArr[i]
    for (var j = delArr.length - 1; j >= 0; j--) {
      var delRow = delArr[j]
      if (row.id == delRow.id) {
        originalArr.splice(i, 1)
      }
    }
  }
}
/**
 * 日期处理
 * @param {*} arr
 */
export function convertToDate (data) {
	debugger;
  if (data == null) {
    return ''
  }
  if (typeof (data) === 'string') {
    var dateStr = data.replace('年', '-').replace('月', '-').replace('日', '')
    var dateArr = dateStr.split('-')
    var getYear = dateArr[0]
    var getMonth = parseInt(dateArr[1]) < 10 ? '0' + parseInt(dateArr[1]) : dateArr[1]
    var getDate = parseInt(dateArr[2]) < 10 ? '0' + parseInt(dateArr[2]) : dateArr[2]
    var validationTime = getYear + '-' + getMonth + '-' + getDate
    return validationTime
  } else {
    return formatTime(data, 'yyyy-MM-dd')
  }
}



// WEBPACK FOOTER //
// ./src/common/common.js